import './banner.css'

export const Banner = () =>{
    return(
       
       <header className = "banner">
            <img src="/imagens/imagens/banner.png" alt="O banner principal da página do Organo" />
        </header>
    )
}

